import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { AiReportsAction } from 'modules/ai_reports/lib/useCreateAnalyticsReportActionResolver'

import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  one: {
    createActions: {
      analyticsReport: AiReportsAction,
    },
  },
} as const satisfies DomainManifest
